//Holds the data thank will be loaded into specific subject cards
//(such as when a user selects "Basic Vowels" from the homepage)

import ConsonantBasicDeckIMG from "../../assets/DeckCards/Phonetics/ConsonantBasicDeckIMG.png";
import ConsonantComplexDeckIMG from "../../assets/DeckCards/Phonetics/ConsonantComplexDeckIMG.png";
import VowelComplexDeckIMG from "../../assets/DeckCards/Phonetics/VowelComplexDeckIMG.png";
import FaceCardFormatterDeck from "../FaceCardFormatterDeck";
import VowelBasicDeckIMG from "../../assets/DeckCards/Phonetics/VowelBasicDeckIMG.png";


export const VowelDeckFace = [

    {
        id: 3,
        Title: "Basic Vowels",
        Description: "Learn basic vowels like ㅑ,ㅠ, and ㅏ!",
        Difficulty: "Beginner 1",
        Image: VowelBasicDeckIMG,
        Link: "/VowelBasicDeck",
        class: "vowel-basic"
    },

    {
        id: 4,
        Title: "Complex Vowels",
        Description: "Learn complex vowels like ㅕ,ㅟ, and ㅙ!",
        Difficulty: "Beginner 1",
        Image: VowelComplexDeckIMG,
        Link: "/VowelComplexDeck",
        class: "vowel-complex"
    }

];


export const ConsonantDeckFace = [

    {
        id: 3,
        Title: "Basic Consonants",
        Description: "Learn basic consonants like ㄷ,ㄴ, and ㅅ!",
        Difficulty: "Beginner 1",
        Image: ConsonantBasicDeckIMG,
        Link: "/ConsonantBasicDeck",
    },

    {
        id: 4,
        Title: "Double Consonants",
        Description: "Learn double consonants like ㅆ,ㄸ, and ㅉ!",
        Difficulty: "Beginner 1",
        Image: ConsonantComplexDeckIMG,
        Link: "/ConsonantComplexDeck",
    }

];

export const ConsonantVowelPairsDeckFace = [

    {
        id: 3,
        Title: "Using ㄱ (k/g)",
        Description: "Learn 가, 간, 규 and more!",
        Difficulty: "Beginner 1",
        Image: ConsonantBasicDeckIMG,
        Link: "/ConsonantVowel_k_Nav",
    },

];







//Export the fully formatted card when called
export function ConsonantDeckFaceCard() {
  return (
        
        <FaceCardFormatterDeck FaceCard={ConsonantDeckFace}/>

        )

}

//Export the fully formatted card when called
export function VowelDeckFaceCard() {
    return (

        <FaceCardFormatterDeck FaceCard={VowelDeckFace}/>
    
    )

}

export function ConsonantVowelPairsDeckFace_Card() {
    return (

        <FaceCardFormatterDeck FaceCard={ConsonantVowelPairsDeckFace}/>
    
    )

}